import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

const loadChildren = () =>
  import('./content.lazy.module').then((module) => module.ContentLazyModule);

const defineImport = (path: string) => ({
  path,
  loadChildren,
});

export const contentLazyImports: ComponentNameAndModule[] = [
  defineImport('AccordionSection'),
  defineImport('ContactSection'),
  defineImport('ExtendedUsps3Section'),
  defineImport('ExtendedUsps4Section'),
  defineImport('FaqSection'),
  defineImport('FunnelContentSection'),
  defineImport('FourTopTasksSection'),
  defineImport('GenericFormSection'),
  defineImport('GenericProductsSection'),
  defineImport('Hero'),
  defineImport('HeroMinimal'),
  defineImport('HeroWithAppButtons'),
  defineImport('HeroWithAsset'),
  defineImport('HeroWithWidget'),
  defineImport('InformationCard2Section'),
  defineImport('InformationCard3Section'),
  defineImport('InformationCard4Section'),
  defineImport('LinkList2Section'),
  defineImport('LinkList3Section'),
  defineImport('LinkList6Section'),
  defineImport('LogosSection'),
  defineImport('StepsSection'),
  defineImport('NotificationSection'),
  defineImport('ReviewEntrySectionAside'),
  defineImport('TextDefault'),
  defineImport('TextDefaultAside'),
  defineImport('TextImageAppSection'),
  defineImport('TextImageSection'),
  defineImport('TextWithCallToActionButton'),
  defineImport('TextWithAppStoreButtons'),
  defineImport('TextWidgetSection'),
  defineImport('ThreeTopTasksSection'),
  defineImport('VideoSection'),
  defineImport('ProductCard2Section'),
  defineImport('ProductCard3Section'),
  defineImport('SimpleUspSection'),
  defineImport('SimpleTable'),
];
